var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 13.333c2.945 0 5.333-2.388 5.333-5.333 0-0.736-0.597-1.333-1.333-1.333h-8c-0.736 0-1.333 0.597-1.333 1.333 0 2.946 2.388 5.333 5.333 5.333zM16 13.333v13.333c0 1.473-1.194 2.667-2.667 2.667s-2.667-1.194-2.667-2.667v-6.667M13.333 6.667v-4M18.667 6.667v-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.9a54cbca0f1eda3cf38652e4864cf1cb.svg";
export { ForwardRef as ReactComponent };